import "antd/es/select/style";
import _Select from "antd/es/select";
var _excluded = ["displayTagsInPopover"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useCallback } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { useDerivedState } from '@huse/derived-state';
import Tag from '@osui/tag';
import Popover from '@osui/popover';
import Select from './InternalBaseSelect';
var DisplayTagsInPopoverSelect = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useDerivedState = useDerivedState(props.value),
      _useDerivedState2 = _slicedToArray(_useDerivedState, 2),
      selectedValue = _useDerivedState2[0],
      setSelectedValue = _useDerivedState2[1];

  var handleChange = useCallback(function (value, option) {
    var _props$onChange;

    setSelectedValue(value);
    (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, value, option);
  }, [props, setSelectedValue]);
  var handleClose = useCallback(function (tag) {
    var newSelectedValue = selectedValue.filter(function (v) {
      return v !== tag.value;
    });
    setSelectedValue(newSelectedValue);
  }, [selectedValue, setSelectedValue]);
  var renderMaxTagPlaceholder = useCallback(function (args) {
    if (!args.length) {
      return null;
    }

    var TagContent =
    /*#__PURE__*/
    // 点击关闭时不要触发select open
    React.createElement("div", {
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      },
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, args.map(function (tag) {
      var _tag$key;

      return /*#__PURE__*/React.createElement(Tag, {
        key: (_tag$key = tag.key) !== null && _tag$key !== void 0 ? _tag$key : tag.value,
        closable: true,
        // eslint-disable-next-line react/jsx-no-bind
        onClose: function onClose() {
          handleClose(tag);
        }
      }, tag.value);
    }));
    return /*#__PURE__*/React.createElement(Popover, {
      content: TagContent
    }, "".concat(args.length, "+..."));
  }, [handleClose]);
  return /*#__PURE__*/React.createElement(Select, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    value: selectedValue,
    onChange: handleChange,
    maxTagCount: "responsive",
    maxTagPlaceholder: renderMaxTagPlaceholder
  }));
});

function EnhancedInternalSelect(props, ref) {
  var displayTagsInPopover = props.displayTagsInPopover,
      restProps = _objectWithoutProperties(props, _excluded);

  if (displayTagsInPopover) {
    return /*#__PURE__*/React.createElement(DisplayTagsInPopoverSelect, _objectSpread(_objectSpread({}, restProps), {}, {
      ref: ref
    }));
  }

  return /*#__PURE__*/React.createElement(Select, _objectSpread(_objectSpread({}, restProps), {}, {
    ref: ref
  }));
}

var EnhancedSelect = /*#__PURE__*/React.forwardRef(EnhancedInternalSelect);
hoistNonReactStatics(EnhancedSelect, _Select);
export default EnhancedSelect;
//# sourceMappingURL=EnhancedInternalSelect.js.map